import React, { useRef, useState } from 'react'
import { Rating } from "react-simple-star-rating";
import './Student_Feedback.css'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Student_Feedback = () => {

    const data = [
        {
            review: "Shares his inspiring journey from medicine to management with DPUCOL’s Online MBA in Hospital Administration & Healthcare Management. With the support of dedicated mentors and a truly flexible platform, he balanced his profession and passion — all from the comfort of his home. Thank you for choosing DPUCOL, Dr Akshay. Your story motivates many.",
            user: "Dr. Akshay Pawar",
            course: "MBA",
            date: "July 22-July 24",
            img: "/assets/images/logo/logo.png",
            Link: "https://www.instagram.com/reel/DLEeCF9vsjT/?utm_source=ig_web_copy_link&igsh=MWM4cWsyMzBtMTludw%3D%3D"
        },
        {
            review: "A Sales Operation Analyst at Tech Mahindra, recently received her MBA degree from DPUCOL. She shares, This MBA has truly helped me grow in my industry. I'm already using the knowledge as real-time experience at work, and I’m very happy to have chosen DPUCOL for my MBA journey. We’re proud to be part of your success story, Shreya!",
            user: "Shreya Prabhu",
            course: "MBA",
            date: "July 21-July 23",
            img: "/assets/images/logo/logo.png",
            Link: "https://www.instagram.com/reel/DKl9UG_B3i1/?utm_source=ig_web_copy_link&igsh=aXR5NzVwejl6Mzdi"
        },
        {
            review: "Here’s what our learner Sachin Pathak has to say — ‘It was an amazing experience! DY Patil gave me the support I needed.’ From gaining real-world skills in AIML to building confidence for his career, Sachin’s MBA journey with DPUCOL is proof that the right learning partner makes all the difference. At DPUCOL, we don’t just deliver degrees — we shape futures. ",
            user: "Sachin Pathak",
            course: "MBA",
            date: "July 22-July 24",
            img: "/assets/images/logo/logo.png",
            Link: "https://www.instagram.com/reel/DK30Ll_uiNR/?utm_source=ig_web_copy_link&igsh=eHh2dmdnb3I5OGxo"
        },
    ]

    const swiperRef = useRef(null);

    const [rating, setRating] = useState(4.5);

    const [swiperInstance, setSwiperInstance] = useState(null);

    const handleMainSliderClick = (direction) => {
        if (!swiperInstance) {
            console.warn("Swiper instance not available yet!");
            return;
        }

        if (direction === "prev") {
            swiperInstance.slidePrev();
        } else if (direction === "next") {
            swiperInstance.slideNext();
        }
    };

    return (
        <section className='Student_Feedback'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-7'>
                        <div className='swiper_div'>
                            <Swiper
                                ref={swiperRef}
                                spaceBetween={15}
                                pagination={{
                                    dynamicBullets: true,
                                    clickable: true
                                }}
                                autoplay={{ delay: 300 }}
                                onSwiper={setSwiperInstance}
                                className="mySwiper"
                                breakpoints={{
                                    0: {
                                        slidesPerView: 1,

                                    },
                                    340: {
                                        slidesPerView: 1.2,
                                        spaceBetween: 5,
                                    },
                                    420: {
                                        slidesPerView: 1.4,
                                        spaceBetween: 5,
                                    },
                                    486: {
                                        slidesPerView: 2,
                                        spaceBetween: 5,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    992: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    1200: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    1400: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                }}
                            >

                                {data?.length > 0 && data?.map((item) => {
                                    return (
                                        <SwiperSlide >
                                            <a href={item?.Link} target='_blank'>
                                                <div className='feedback_card'>
                                                    <div className='rating_div'>
                                                        <Rating
                                                            initialValue={rating}
                                                            fillColor="#f4a51c"
                                                            className="react-simple-star-rating start"
                                                            SVGclassName="star-svg"
                                                            readonly={true} // This makes the rating display-only
                                                        />
                                                    </div>

                                                    <p className='review_text'>{item?.review}</p>

                                                    <div className='footer_div'>
                                                        <div className='img_holder'>
                                                            <img src={item?.img} className='profile_img' />
                                                        </div>
                                                        <div className='text_holder'>
                                                            <p className='user'>{item?.user}</p>
                                                            {/* <p className='course_text'>{item?.course} <span className='black_text'>({item?.date})</span></p> */}
                                                            <p className='course_text'>{item?.course} </p>
                                                        </div>
                                                    </div>

                                                    <div className='quote_img_holder'>
                                                        <img src='/assets/images/home/student_feedback/quote.png' className='quote_img' />
                                                    </div>

                                                </div>
                                            </a>

                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        </div>
                    </div>
                    <div className='col-lg-5'>
                        <div className='right_side'>
                            <p className='title_text'>Student Feedback</p>
                            <p className='descn_text'>
                                Your opinion matters, and by providing feedback, you
                                contribute to the continuous enhancement of our
                                academic programs, support services, and campus life
                            </p>

                            <div className="silder_btn">
                                <div
                                    className="back_btn"
                                    onClick={() => handleMainSliderClick("prev")}
                                >
                                    <FontAwesomeIcon icon={faAngleLeft} className='icon' />
                                </div>
                                <div
                                    className="back_btn"
                                    onClick={() => handleMainSliderClick("next")}
                                >
                                    <FontAwesomeIcon icon={faAngleRight} className='icon' />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Student_Feedback
